import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import { Card } from '../Card/Card';
import DialogActions from '@material-ui/core/DialogActions';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { ProfileCardHeader } from '../ProfileCard/ProfileCardHeader';
import { CardBody } from '../Card/CardBody';
import Fab from '@material-ui/core/Fab';
import EditIcon from '@material-ui/icons/Edit';
import { Form, FormInput, FormSelect } from '../../core/Formikfy';
import MenuItem from '@material-ui/core/MenuItem';
import DeleteIcon from '@material-ui/icons/Delete';
import Typography from '@material-ui/core/Typography';
import Link from '@material-ui/core/Link';
import { useNavigate } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  form: {
    width: '100%',
    marginTop: theme.spacing(1),
  },
  formInput: {
    margin: '10px',
  },
  contentHeading: {
    textAlign: 'left',
    fontSize: '1rem',
    fontWeight: 700,
    color: '#3C4858',
  },
  contentSubHeading: {
    textAlign: 'left',
    textTransform: 'uppercase',
    marginBottom: '20px',
    fontSize: '0.75rem',
    fontWeight: 400,
    color: '#999',
  },
  cardContent: {
    position: 'relative',
    [theme.breakpoints.down('sm')]: {
      padding: '20px 0px 5px 40px',
    },
    [theme.breakpoints.up('sm')]: {
      padding: '15px 0px 0px 75px',
    },
  },
  editButton: {
    color: 'primary',
    [theme.breakpoints.down('sm')]: {
      right: '0',
      top: '-27px',
      fontSize: 'small',
    },
    [theme.breakpoints.up('sm')]: {
      top: '-20px',
      right: '-20px',
    },
    position: 'absolute',
  },
  cardSubHeadingText: {
    fontWeight: 200,
    color: '#E6E6E6',
    [theme.breakpoints.down('sm')]: {
      fontSize: '12px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
    },
  },
  cardHeadingText: {
    fontWeight: 900,
    [theme.breakpoints.down('sm')]: {
      fontSize: '14px',
    },
    [theme.breakpoints.up('sm')]: {
      fontSize: '16px',
    },
  },
  root: {
    margin: '15px 0',
    [theme.breakpoints.down('sm')]: {
      width: '250px',
    },
    [theme.breakpoints.up('sm')]: {
      width: '500px',
    },
    paddingRight: '10px',
  },
}));

export function ProfileTile(props) {
  const { tile, tileId, updateTile, deleteTile, currentUserInfo } = props;
  const classes = useStyles();
  const AIESECRoles = ['LCVP', 'Manager', 'Team Leader', 'Specialist', 'Team Member'];
  const [tileDialogBoxOpen, setTileDialogBoxOpen] = React.useState(false);
  const [position, setPosition] = useState('Team Member');
  const [tileIndex, setTileIndex] = useState(0);
  const navigate = useNavigate();

  useEffect(() => {
    setTileIndex(tileId);
    setPosition(tile.position);
  }, []);

  return (
    <div className={classes.root}>
      <ProfileCardHeader type="Profile Card" src={tile.dp} />
      <Card
        style={{
          margin: '0 0 0 15px',
          backgroundColor:
            tile.position === 'LCP' || tile.position === 'LCVP' || tile.position === 'Manager'
              ? '#F85A40'
              : '#0258AA',
          borderRadius: '3px',
          color: 'white',
        }}
        elevation={2}
      >
        <CardBody
          // style={{ padding: '10px 10px 10px 20px', position: 'relative' }}
          style={{ paddingBottom: '15px' }}
          className={classes.cardContent}
        >
          {currentUserInfo.role === 'admin' && (
            <Fab
              className={classes.editButton}
              onClick={() => setTileDialogBoxOpen(true)}
              size="small"
            >
              <EditIcon />
            </Fab>
          )}

          {/*Tile dialog box*/}
          <Dialog
            disableEnforceFocus
            open={tileDialogBoxOpen}
            onClose={() => setTileDialogBoxOpen(false)}
            aria-labelledby="form-dialog-title"
          >
            <DialogTitle id="form-dialog-title">Update Profile</DialogTitle>
            <Form
              className={classes.form}
              initialValues={{
                positionName: tile.positionName,
              }}
              onSubmit={async (data) => {
                try {
                  updateTile({
                    data: {
                      id: tile.id,
                      position: position,
                      positionName: data.positionName,
                    },
                    tileId: tileIndex,
                  });
                } catch (e) {
                  console.error(e);
                }
              }}
            >
              <DialogContent>
                <DialogContentText>
                  Enter team member information to update the details
                </DialogContentText>
                <div style={{ marginLeft: '10px' }}>
                  <FormSelect
                    type="text"
                    label="Position"
                    name="position"
                    value={position}
                    onChange={(event) => setPosition(event.target.value)}
                    variant="standard"
                    fullWidth={true}
                  >
                    {AIESECRoles.map((position) => (
                      <MenuItem value={position}>{position}</MenuItem>
                    ))}
                  </FormSelect>
                </div>
                <div style={{ marginLeft: '10px' }}>
                  <FormInput
                    type="text"
                    label="Position Name"
                    name="positionName"
                    variant="standard"
                    fullWidth={true}
                  />
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={() => setTileDialogBoxOpen(false)} color="primary">
                  Cancel
                </Button>
                <Button type="submit" onClick={() => setTileDialogBoxOpen(false)} color="primary">
                  Update
                </Button>
                <IconButton
                  style={{ right: '0', top: '0', position: 'absolute' }}
                  color="primary"
                  onClick={() => deleteTile(tileIndex)}
                >
                  <DeleteIcon />
                </IconButton>
              </DialogActions>
            </Form>
          </Dialog>
          <Typography className={classes.cardHeadingText}>
            <Link
              onClick={() => navigate(`/app/profile/${tile.id}`, { replace: true })}
              color="inherit"
            >
              {tile.name}
            </Link>
          </Typography>
          <Typography className={classes.cardSubHeadingText}>
            {tile.position} - {tile.positionName}
          </Typography>
        </CardBody>
      </Card>
    </div>
  );
}
